import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import TestFetch from '../TestFetch'

export default ({
    storeTargetTestFetch
}) =>
    <Grid container direction="column" style={{ padding: '16px' }}>
        <Typography variant="h3">{'TODO a real test page'}</Typography>
        <TestFetch storeTarget={storeTargetTestFetch} />
    </Grid>